import { Companion_getInstanceswkziix95xfy as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/PrimitiveRanges.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_indices3txodfl5wuu5j as get_indices } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EmptyClass;
function Empty() {
  if (EmptyClass === VOID) {
    class $ {
      get_range_ixu978_k$() {
        return Companion_getInstance().EMPTY_1;
      }
      get_kdo3gu_k$(index) {
        return Unit_instance;
      }
      get_c1px32_k$(index) {
        this.get_kdo3gu_k$(index);
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'Empty', VOID, VOID, [RecyclerViewData()]);
    EmptyClass = $;
  }
  return EmptyClass;
}
var Empty_instance;
function Empty_getInstance() {
  return Empty_instance;
}
var FromListClass;
function FromList() {
  if (FromListClass === VOID) {
    class $ {
      constructor(list) {
        this.list_1 = list;
        this.range_1 = get_indices(this.list_1);
      }
      get_range_ixu978_k$() {
        return this.range_1;
      }
      get_c1px32_k$(index) {
        if (!(0 <= index ? index <= (this.list_1.get_size_woubt6_k$() - 1 | 0) : false))
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('Index ' + index + ' out of range for ' + get_indices(this.list_1).toString());
        return this.list_1.get_c1px32_k$(index);
      }
    }
    initMetadataForClass($, 'FromList', VOID, VOID, [RecyclerViewData()]);
    FromListClass = $;
  }
  return FromListClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      fromList_66mo8k_k$(list) {
        return new (FromList())(list);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var RecyclerViewDataClass;
function RecyclerViewData() {
  if (RecyclerViewDataClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RecyclerViewData');
    RecyclerViewDataClass = $;
  }
  return RecyclerViewDataClass;
}
//region block: init
Empty_instance = new (Empty())();
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  RecyclerViewData as RecyclerViewDatag1ccuuuhm5zb,
  Companion_instance as Companion_instance10d5r88v1hr3l,
  Empty_instance as Empty_instance2ua06mt98yjia,
};
//endregion

//# sourceMappingURL=RecyclerViewData.mjs.map
